import { render, staticRenderFns } from "./technicians-detail.vue?vue&type=template&id=7fc06f6e&scoped=true&"
import script from "./technicians-detail.vue?vue&type=script&lang=js&"
export * from "./technicians-detail.vue?vue&type=script&lang=js&"
import style0 from "./technicians-detail.vue?vue&type=style&index=0&id=7fc06f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc06f6e",
  null
  
)

export default component.exports